import { IPublicClientApplication } from "@azure/msal-browser";
import { IStudentDetails } from "../models/StudentDetails";
import { BaseService } from "./base.service";

export class StudentService extends BaseService {
  constructor(instance: IPublicClientApplication) {
    super(instance);
  }

  public async getStudentDetails(studentId: string): Promise<IStudentDetails> {
    // Original
    // var options = this.getHeaderOption("GET");
    // const response = await fetch(
    //   `${this.getEndPoint()}/api/examiner/GetStudentDetails?studentId=${studentId}`,
    //   options
    // );

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/api/examiner/GetStudentDetails?studentId=${studentId}`;
    const method = "GET";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      const responseAsJson = await response.json();
      return responseAsJson;
    }
    throw "Invalid examiner response";
  }
}
